import store from '@/uteis/store'
import md5 from 'md5'

import ProcessoElaboracaoService from '@/services/ProcessoElaboracaoService'
import NumeroProcessoService from '@/services/NumeroProcessoService'
import VirtusService from '@/services/VirtusService'
import DestinatarioService from '@/services/DestinatarioService'
import DadosFixosService from '@/services/DadosFixosService'

const convertSigiloso = (sigiloso) => {
  if (sigiloso === 'Não') return 'NAO'
  if (sigiloso === 'Sim') return 'SIM'
  return sigiloso
}

const convertTipoDocumento = (tipoDocumento) => {
  if (tipoDocumento === 'Simples') return 'SIMPLES'
  if (tipoDocumento === 'Composto') return 'COMPOSTO'
  return tipoDocumento
}

const convertTipoContatoExterno = (tipoContatoExterno) => {
  const map = {
    'Pessoa Física': 'PESSOAFISICA',
    'Pessoa Jurídica': 'PESSOAJURIDICA',
    'Poder Executivo Estadual': 'PODEREXECUTIVO',
    Matrícula: 'SERVIDOR',
    Servidor: 'SERVIDOR'
  }

  return map[tipoContatoExterno]
}

const convertTipoProtocolo = (tipoContatoExterno) => {
  const map = {
    'Documento Avulso': 'DOCUMENTO_AVULSO',
    'Documento avulso': 'DOCUMENTO_AVULSO',
    Processo: 'PROCESSO'
  }

  return map[tipoContatoExterno]
}

const convertInteressados = (interessadosVirtus) => {
  const interessados = interessadosVirtus.map((interessado) => {
    return {
      idInteressado: md5(interessado),
      tipoContatoExterno: convertTipoContatoExterno(interessado.tipo),
      nome: interessado.nome,
      identificador: interessado.identificador,
      email: interessado.contato
    }
  })
  return interessados
}

const convertProcessoVirtusToPae = (processo, numeroProcesso) => {
  return {
    tipoProcesso: processo.atributos.tipoProcesso, // atributos.tipoProcesso
    sigiloso: convertSigiloso(processo.atributos.sigiloso), // atributos.sigiloso -> tranformar para "NAO" ou "SIM"
    complementoSetor: processo.atributos.textoComplemento, // atributos.textoComplemento
    usuarioCriacao: processo.autor.identificador, // autor.identificador
    nomeUsuario: processo.autor.nome, // autor.identificador
    idOrgao: processo.atributos.idOrgao, // atributos.idOrgao
    siglaOrgao: processo.atributos.siglaOrgao, // atributos.siglaOrgao
    idDepartamento: processo.atributos.idDepartamento, // atributos.idDepartamento
    siglaDepartamento: processo.atributos.siglaDepartamento, // atributos.siglaDepartamento
    codigoHierarquia: processo.atributos.codigoHierarquia, // atributos.codigoHierarquia
    cidade: processo.atributos.cidade, // atributos.cidade
    estado: processo.atributos.estado, // atributos.estado
    telefone: processo.atributos.telefone, // atributos.telefone
    situacao: 'ATIVO', // atributos.situacao -> se existir colocar o dado, se não retorna true
    tipoDocumento: convertTipoDocumento(processo.atributos.tipoDocumento), // atributos.tipoDocumento -> coloca no padrão usado no sistema
    tipoProtocolo: convertTipoProtocolo(processo.atributos.tipoProtocolo), // atributos.tipoProtocolo -> coloca no padrão usado no sistema
    numeroProcesso: numeroProcesso,
    assunto: {},
    numeroAnexos: processo.atributos.numeroAnexos, // atributos.numeroAnexos
    interessados: convertInteressados(processo.atributos.interessados),
    idEspecie: processo.atributos.codigoEspecie, // atributos.codigoEspecie
    assuntoDescricao: processo.atributos.assunto, // atributos.codigoEspecie
    especieDescricao: processo.atributos.especie // atributos.especie
  }
}

export const buscarProcessoEdicao = async (numeroProcesso, numeroProcessoObjeto) => {
  const processoElaboracaoService = new ProcessoElaboracaoService()
  let { data: processo } = await processoElaboracaoService.buscarProcessoParaEdicao(numeroProcesso)
  processo = convertProcessoVirtusToPae(processo, numeroProcessoObjeto)
  const virtusService = new VirtusService()
  const atributos = await virtusService.buscarVolumesDoProcesso(numeroProcesso)

  const dadosFixosService = new DadosFixosService()
  const especies = processo.idEspecie ? await dadosFixosService.buscarEspeciePorId(processo.idEspecie) : null

  if (atributos) {
    processo.volume = atributos.volumeAtual ? String(atributos.volumeAtual).padStart(3, '0') : ''
  }

  if (especies && especies.data[0]) {
    processo.especie = {
      assunto: processo.assunto,
      ...especies.data[0]
    }
    processo.assunto = especies.data[0].assunto
  }

  if (!processo.especie) {
    const assunto = await dadosFixosService.buscarAssunto({
      filtro: processo.assuntoDescricao,
      idOrgao: store.getters.getDadosSessao.sessao.idOrgao
    })
    processo.assunto = assunto.data[0] || {}
    processo.idAssunto = processo.assunto ? processo.assunto.id : 0
    processo.especie = {}
  }

  processo.numeroAnexos = processo.numeroAnexos || 0
  processo.tipoDocumento = processo.tipoDocumento || 'SIMPLES'

  return processo
}

export const criarModeloProcesso = async (numeroProcesso, numeroProcessoObjeto) => {
  const processo = await buscarProcessoEdicao(numeroProcesso, numeroProcessoObjeto)
  const dadosSessao = store.getters.getDadosSessao
  const tipoProtocolo = processo.tipoProtocolo
  processo.interessados.forEach(item => {
    delete item.idInteressado
  })
  processo.numeroProcesso = {}

  return {
    ...processo,
    id: '',
    usuarioCriacao: '',
    nomeUsuario: '',
    idDepartamento: '',
    siglaDepartamento: '',
    codigoHierarquia: '',
    numeroProcesso: {
      tipoProtocolo: tipoProtocolo
    },
    sessaoUsuario: dadosSessao.sessao
  }
}

export const buscarProcessoNovo = async (numeroProcesso, numeroProcessoObjeto) => {
  const destinatarioService = new DestinatarioService()

  const processo = store.getters.getProcesso
  const dadosSessao = store.getters.getDadosSessao
  const parametros = {
    codHierarquia: dadosSessao.sessao.codigoHierarquia
  }

  return destinatarioService.buscarDepartamento(parametros).then((response) => {
    const departamento = response.data.data[0]
    return {
      ...processo,
      sessaoUsuario: dadosSessao.sessao,
      sigiloso: 'NAO',
      tipoProcesso: 'FISICO',
      tipoDocumento: 'SIMPLES',
      numeroAnexos: 0,
      numeroProcesso: numeroProcessoObjeto,
      cidade: departamento ? departamento.cidade : '',
      estado: departamento ? departamento.estado : '',
      telefone: departamento ? departamento.telefone : ''
    }
  })
}

export const editarProcesso = async () => {
  const processoElaboracaoService = new ProcessoElaboracaoService()
  const dadosSessao = store.getters.getDadosSessao
  const processo = {
    ...store.getters.getProcesso,
    sessaoUsuarioEdicao: dadosSessao.sessao,
    interessados: getInteressadosSelecionado()
  }

  return processoElaboracaoService.editar(processo).then(() => {
    return processo
  })
}

export const salvarProcesso = async (processo) => {
  const processoElaboracaoService = new ProcessoElaboracaoService()

  return processoElaboracaoService.salvar(processo).then(() => {
    return processo
  })
}

export const criarNumeroProcesso = async (idOrgao, tipoProtocolo) => {
  const numeroProcessoService = new NumeroProcessoService()
  return numeroProcessoService.criarNumeroProcesso(idOrgao, tipoProtocolo)
}

export const salvarProcessoReservado = async () => {
  const processo = store.getters.getProcesso
  return salvarProcesso(processo)
}

const getKeyInteressado = (tipoContatoExterno) => {
  if (tipoContatoExterno === 'PESSOAFISICA') return 'cpf'
  if (tipoContatoExterno === 'PESSOAJURIDICA') return 'cnpj'
  if (tipoContatoExterno === 'INSCRICAOESTADUAL') return 'inscricaoEstadual'
  if (tipoContatoExterno === 'PODEREXECUTIVO') return 'estruturaId'
  if (tipoContatoExterno === 'SERVIDOR') return 'matricula'
  return 'identificador'
}

const getInteressadosSelecionado = () => {
  const interessados = store.getters.getInteressadosSelecionado
  interessados.forEach((interessado) => {
    interessado.identificador = interessado.identificador || ''
  })
  return interessados
}

const getInteressadosVirtus = () => {
  const interessadosSelecionados = store.getters.getInteressadosSelecionado
  interessadosSelecionados.forEach((interessado) => {
    interessado.identificador = interessado.identificador || ''
  })
  const interessados = interessadosSelecionados.map((interessado) => {
    const identificador = interessado.identificador
    const tipoIdenficador = getKeyInteressado(interessado.tipoContatoExterno)
    return {
      id: interessado.id,
      tipoContatoExterno: interessado.tipoContatoExterno,
      nome: interessado.nome,
      email: interessado.email,
      [tipoIdenficador]: identificador
    }
  })
  return interessados
}

const inserirDados = (processoForms) => {
  const processo = { ...processoForms }

  processo.usuarioCriacao = !processo.sessaoUsuario ? processo.usuarioCriacao : processo.sessaoUsuario.login
  processo.nomeUsuario = !processo.sessaoUsuario ? processo.nomeUsuario : processo.sessaoUsuario.nomeUsuario
  processo.idOrgao = !processo.sessaoUsuario ? processo.idOrgao : processo.sessaoUsuario.idOrgao
  processo.siglaOrgao = !processo.sessaoUsuario ? processo.siglaOrgao : processo.sessaoUsuario.siglaOrgao
  processo.descricaoOrgao = !processo.sessaoUsuario ? processo.descricaoOrgao : processo.sessaoUsuario.descricaoOrgao
  processo.idDepartamento = !processo.sessaoUsuario ? processo.idDepartamento : processo.sessaoUsuario.idDepartamento
  processo.siglaDepartamento = !processo.sessaoUsuario ? processo.siglaDepartamento : processo.sessaoUsuario.siglaDepartamento
  processo.descricaoDepartamento = !processo.sessaoUsuario ? processo.descricaoDepartamento : processo.sessaoUsuario.descricaoDepartamento
  processo.codigoHierarquia = !processo.sessaoUsuario ? processo.codigoHierarquia : processo.sessaoUsuario.codigoHierarquia
  processo.textoComplemento = processo.complementoSetor
  processo.sigiloso = !processo.sigiloso && processo.sigiloso === '' ? 'NAO' : processo.sigiloso
  processo.tipoDocumento = !processo.tipoDocumento && processo.tipoDocumento === '' ? 'SIMPLES' : processo.tipoDocumento
  processo.situacao = true

  const idEspecie = processo.idEspecie ? processo.idEspecie.toString().trim() : ''
  if (idEspecie === '') processo.idEspecie = processo.especie.codigoEspecie

  const especieDescricao = processo.especieDescricao ? processo.especieDescricao.toString().trim() : ''
  if (especieDescricao === '') processo.especieDescricao = processo.especie.especie

  return processo
}

export const salvarNovoProcesso = async () => {
  const processo = inserirDados(store.getters.getProcesso)
  const interessados = getInteressadosVirtus()
  const dadosSessao = store.getters.getDadosSessao

  const idOrgao = dadosSessao.sessao.idOrgao
  const tipoProtocolo = processo.numeroProcesso.tipoProtocolo

  return criarNumeroProcesso(idOrgao, tipoProtocolo)
    .then((numeroProcesso) => {
      processo.numeroProcesso = numeroProcesso
      return salvarProcesso({ ...processo, interessados })
    })
}

export const retornarProcesso = async (processo) => {
  return processo
}
